/* Motion and pointer affordances live in Toggle.interaction.module.css. */
.root {
  display: inline-flex;
  align-items: center;
  column-gap: var(--spacing-ds-2);
  border-width: var(--border-ds-width-none);
  padding: var(--spacing-ds-0);
}

/*
 * The track, not the button, carries the switch geometry: the button also
 * hosts an optional label, so its own box has to stay neutral.
 */
.track {
  display: inline-flex;
  align-items: center;
  position: relative;
  flex-shrink: var(--flex-ds-shrink-none);
  border-radius: var(--radius-ds-pill);
}

.track-md {
  height: var(--size-ds-toggle-track-height-md);
  width: var(--width-ds-toggle-track-md);
  padding: var(--spacing-ds-0-5);
  border-width: var(--border-ds-width-hairline);
}

.track-sm {
  height: var(--size-ds-toggle-track-height-sm);
  width: var(--width-ds-toggle-track-sm);
  padding: var(--spacing-ds-0);
  border-width: var(--border-ds-width-thick);
}

.track-lg {
  height: var(--size-ds-toggle-track-height-lg);
  width: var(--width-ds-toggle-track-lg);
  padding: var(--spacing-ds-0-5);
  border-width: var(--border-ds-width-hairline);
}

.thumb {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--radius-ds-pill);
}

.thumb-md {
  height: var(--size-ds-toggle-thumb-md);
  width: var(--size-ds-toggle-thumb-md);
}

.thumb-sm {
  height: var(--size-ds-toggle-thumb-sm);
  width: var(--size-ds-toggle-thumb-sm);
}

.thumb-lg {
  height: var(--size-ds-toggle-thumb-lg);
  width: var(--size-ds-toggle-thumb-lg);
}

.thumb-off {
  translate: var(--translate-ds-none);
}

.thumb-on-md {
  translate: var(--translate-ds-toggle-md);
}

.thumb-on-sm {
  translate: var(--translate-ds-toggle-sm);
}

.thumb-on-lg {
  translate: var(--translate-ds-toggle-lg);
}
